import { environment } from '../../environments/environment';

export const API_REQUEST_HEADERS = {
    appVersion: environment.appVersion
};
